import React from "react";
import { useSettings } from "@/context/SettingsContext";
import { Megaphone } from "lucide-react";

export default function Marquee() {
  const { settings } = useSettings();
  const text = (settings?.marquee_text || "").trim();
  if (!settings?.marquee_live || !text) return null;

  const items = Array.from({ length: 4 });
  return (
    <div className="bg-brand-emerald text-white overflow-hidden relative shadow-sm" data-testid="home-marquee">
      <div className="flex items-center gap-2 py-2.5">
        <div className="marquee-track flex whitespace-nowrap">
          {items.map((_, i) => (
            <span key={i} className="inline-flex items-center gap-2 px-8 text-sm font-medium">
              <Megaphone className="w-4 h-4 shrink-0" /> {text}
            </span>
          ))}
        </div>
        <div className="marquee-track flex whitespace-nowrap" aria-hidden="true">
          {items.map((_, i) => (
            <span key={i} className="inline-flex items-center gap-2 px-8 text-sm font-medium">
              <Megaphone className="w-4 h-4 shrink-0" /> {text}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
